import { Component } from '@angular/core';
import { Page } from '../shared/page/page';

@Component({
  selector: 'app-main',
  imports: [Page],
  templateUrl: './main.html',
  styleUrls: ['./main.sass']
})
export class Main {

}
